import { $ } from './../../helpers/query'
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class GalleryAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
    this.gallerySection = document.querySelector('#gallery-section');
    this.galleryDecor = this.gallerySection.querySelector('.gallery__decoration');
    this.galleryElems = $('.gallery__elem', this.gallerySection);
  }

  // 1. Interract whith Previous section
  // -- 1.1. Interract forward
  onVisitDown() {
    this.hideVideo()
    this.setCssTransition('step-start')
    this.galleryDecor.classList.remove('gallery__decoration--start')
    setTimeout(() => {
      this.galleryElems.each((elem, i) => {
        elem.style.transitionDelay = i * 0.05 + 's';
      })
      this.galleryElems.removeClass('gallery__elem--start')
    }, 50)
    setTimeout(() => {
      this.resetCssTransition()
      this.galleryElems.css({ 'transition-delay': '' })
    }, this.ANIM_DUR)
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }

  // -- 1.2. Interract back
  onLeaveUp() {
    window.dispatchEvent(this.transitionStart)
    this.setCssTransition('ease')
    setTimeout(() => {
      this.resetCssTransition()
    }, this.ANIM_DUR)
    setTimeout(() => {
      this.galleryElems.addClass('gallery__elem--start')
      this.galleryDecor.classList.add('gallery__decoration--start')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // 2. Interract whith Next section
  // -- 2.1. Interract forward
  onLeaveDown() {
    window.dispatchEvent(this.transitionStart)
  }

  // -- 2.2. Interract back
  onVisitUp() {
    this.onVisitDown()
  }

}
